import { DefaultSelect } from 'common/components'

type SelectInsurancePlanReasonProps = {
  inputName: string
}

const REASONS = [
  'Remodel Health',
  'Stride Health',
  'Healthcare.gov exchange',
  'State-based exchange (such as Covered California, Connect for Health Colorado)',
  'Local health insurance broker',
  'Health insurance carrier’s website (such as aetna.com)',
  'Other',
]

function SelectInsurancePlanReason({ inputName }: SelectInsurancePlanReasonProps) {
  return (
    <DefaultSelect
      label="How did you select and enroll in your health insurance plan?"
      labelStyles="mb-12"
      name={inputName}
      placeholder="Choose source"
      showRequiredSign={true}
      items={REASONS.map((item, id) => ({ name: item, id }))}
    />
  )
}

export default SelectInsurancePlanReason
